var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 13H13V35H35V13Z",
    fill: "url(#paint0_radial_25993_214925)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4318 26.0464L16.6055 23.2353L18.7138 21.127L23.6027 26.0006C23.8166 26.2145 24.1832 26.2145 24.3971 26.0006L29.286 21.127L31.3944 23.2353L28.568 26.0617C28.0485 26.5811 27.3305 26.8867 26.5818 26.8867H21.418C20.6693 26.8714 19.9666 26.5811 19.4318 26.0464Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_25993_214925",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4408 16.1118) rotate(135.684) scale(21.4426 21.4441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#9CFFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39372,
    stopColor: "#32F26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610145,
    stopColor: "#00D15F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeeam);
export default __webpack_public_path__ + "static/media/Veeam.b50e0457bb33140d5a83e1d3e9b3ab8c.svg";
export { ForwardRef as ReactComponent };